var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleFilledCross = function SvgCircleFilledCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.058 8l-1.53-1.53a.667.667 0 11.942-.943L8 7.057l1.533-1.532a.667.667 0 11.943.942L8.943 8l1.528 1.528a.667.667 0 11-.942.943L8 8.943 6.472 10.47a.667.667 0 11-.943-.942l1.529-1.53zM8 15.333A7.333 7.333 0 118 .666a7.333 7.333 0 010 14.667z"
  })));
};
export default SvgCircleFilledCross;